import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CoreModule } from "./core/core.module";
import { SharedModule } from "./shared/shared.module";

import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HeaderComponent } from "./layout/header/header.component";
import { PageLoaderComponent } from "./layout/page-loader/page-loader.component";
import { SidebarComponent } from "./layout/sidebar/sidebar.component";
import { RightSidebarComponent } from "./layout/right-sidebar/right-sidebar.component";
import { AuthLayoutComponent } from "./layout/app-layout/auth-layout/auth-layout.component";
import { MainLayoutComponent } from "./layout/app-layout/main-layout/main-layout.component";
// import { fakeBackendProvider } from "./core/interceptor/fake-backend";
import { ErrorInterceptor } from "./core/interceptor/error.interceptor";
// import { JwtInterceptor } from "./core/interceptor/jwt.interceptor";
import { LocationStrategy, HashLocationStrategy } from "@angular/common";
import {
  PerfectScrollbarModule,
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface,
} from "ngx-perfect-scrollbar";
import { TranslateModule, TranslateLoader, } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { ClickOutsideModule } from "ng-click-outside";
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient, } from "@angular/common/http";

import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
// import { AngularFireModule } from "@angular/fire";
import { AngularFireDatabaseModule } from "@angular/fire/database";
import { environment } from "src/environments/environment";
import { PatientService } from "./patient/Shared/patient.service";
import firebase from 'firebase/app';
import { NgxUiLoaderConfig, NgxUiLoaderHttpModule, NgxUiLoaderModule } from "ngx-ui-loader";
import { SocialLoginModule, SocialAuthServiceConfig, FacebookLoginProvider } from 'angularx-social-login';
import { GoogleLoginProvider } from 'angularx-social-login';
import { ImageCropperModule } from "ngx-image-cropper";
import { AgmCoreModule } from "@agm/core";
import { MatCarouselModule } from "ng-mat-carousel";
import { WebcamModule } from "ngx-webcam";
import { ZXingScannerModule } from "@zxing/ngx-scanner";





const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelPropagation: false,
};

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: '#0af0d5',
  // Loader Design Change from here
  fgsType: "ball-spin-clockwise",
  bgsSize: 60,
  pbThickness: 5, // progress bar thickness
  fgsColor: '#0af0d5',
  pbColor: '#0af0d5'
};

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyDjWlVqdG8rVQxGtGdjtmp2tgMgJD8bmsk",
  authDomain: "techtrial-taxi.firebaseapp.com",
  projectId: "techtrial-taxi",
  storageBucket: "techtrial-taxi.appspot.com",
  messagingSenderId: "161097084830",
  appId: "1:161097084830:web:cc7f038017b0d31edd308f",
  measurementId: "G-EZS6BNEZD1"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    PageLoaderComponent,
    SidebarComponent,
    RightSidebarComponent,
    AuthLayoutComponent,
    MainLayoutComponent,

  ],
  imports: [
    BrowserModule,
    ImageCropperModule,
    // AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ZXingScannerModule,
    HttpClientModule,
    WebcamModule,
    PerfectScrollbarModule,
    ClickOutsideModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    // core & shared
    CoreModule,
    SharedModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderHttpModule.forRoot({ showForeground: true }),
    SocialLoginModule,
    NgxMaterialTimepickerModule.setLocale('en-US'),

    AgmCoreModule.forRoot({
      // apiKey: 'AIzaSyC31zWfzkQlbh7jZJGsoCFGLICf97A8OEs', //old key
      apiKey: 'AIzaSyAiexgq0AARMXmbjNCbn9aLjtMpH2iKXs4', // New Key
      libraries: ['places']
    }),
    MatCarouselModule.forRoot(),
  ],
  providers: [
    // { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    // { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    // fakeBackendProvider,
    PatientService,
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              environment.google
            )
          },
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider(environment.facebook)
          },
        ]
      } as SocialAuthServiceConfig,
    }
  ],
  entryComponents: [],
  bootstrap: [AppComponent],
})
export class AppModule { }
